export const MINIMUM_NUMBER_OF_STAY_DAYS = 28;
export const MAXIMUM_NUMBER_OF_STAY_MONTHS = 6;
export const MAXIMUM_NUMBER_OF_STAY_DAYS = 185;
export const DATEPICKER_DATE_FORMAT = "d. MMMM yyyy";
export const DATEPICKER_DATE_FORMAT_SHORT = "d. LLL. yyyy";
export const DATE_AS_STR_FORMAT = "yyyy-MM-dd";
